import {t} from 'i18next';
import AurDialog, {DialogProps} from '../../common/aur-dialog/AurDialog';
import {ReactComponent as InfoAlertIcon} from '../../../assests/svg/warning-blue-icon.svg';
import {Typography} from '@mui/material';
import {QueryValidationType} from '../../../utils/utils';

interface QueryBuilderClearConfirmationAlertProps {
  showDialog: DialogProps['showDialog'];
  onOk: DialogProps['onOk'];
  onCancel: DialogProps['onCancel'];
  queryErrorTypes?: QueryValidationType[];
}

const stringPath = 'indexSearchPage.queryWarningPopup.';

const getLowerErrorMessage = (
  errors: QueryValidationType[]
): string | undefined => {
  let message: string | undefined = undefined;

  const groupedErrors: QueryValidationType[] = [
    'LOWERCASE_OPERATORS',
    'PROXIMITY_W',
    'PROXIMITY_P',
  ];

  const groupedFound = errors.filter((error) =>
    groupedErrors.includes(error as QueryValidationType)
  );

  if (groupedFound.length > 1) {
    message = stringPath + 'lowerCaseMsg';
  } else if (groupedFound.length === 1) {
    switch (groupedFound[0]) {
      case 'LOWERCASE_OPERATORS':
        message = stringPath + 'lowerCaseMsg';
        break;
      case 'PROXIMITY_W':
        message = stringPath + 'proximityWMsg';
        break;
      case 'PROXIMITY_P':
        message = stringPath + 'proximityPreMsg';
        break;
    }
  }
  return message;
};

const QueryWarningPopupAlert = ({
  showDialog,
  onCancel,
  onOk,
  queryErrorTypes = [],
}: QueryBuilderClearConfirmationAlertProps) => {
  const renderDynamicContent = () => {
    const wrongReasonList = t(
      'indexSearchPage.queryWarningPopup.queryWrongReasonList',
      {returnObjects: true}
    ) as string[];
    return (
      <>
        {queryErrorTypes.includes('UNSUPPORTED') && (
          <>
            <Typography className="typo-text subhead4_size reason-title-text">
              {t(stringPath + 'unsupportedSyntaxTitle')}
            </Typography>
            <Typography className="typo-text body2_size">
              {t(stringPath + 'unsupportedSyntaxMsg')}
            </Typography>
            <ul>
              {wrongReasonList.map((value) => (
                <li key={`reason_${value}`}>
                  <Typography className="typo-text body2_size">
                    {value}
                  </Typography>
                </li>
              ))}
            </ul>
          </>
        )}

        {getLowerErrorMessage(queryErrorTypes) && (
          <>
            <Typography className="typo-text subhead4_size reason-title-text">
              {t(stringPath + 'lowerCaseTitle')}
            </Typography>
            <Typography className="typo-text body2_size">
              {t(getLowerErrorMessage(queryErrorTypes) ?? '')}
            </Typography>
          </>
        )}

        <Typography className="typo-text subhead4_size reason-title-text mt-16">
          {t(stringPath + 'doYouWentContinueTitle')}
        </Typography>
        <Typography className="typo-text body2_size">
          {t(stringPath + 'doYouWentContMsg')}
        </Typography>
      </>
    );
  };

  return (
    <AurDialog
      showDialog={showDialog}
      className={'clear-confim-alert-cancel-dialog query-warning-popup'}
      dialogTitle={t(stringPath + 'dialogTitle')}
      type="alert"
      popupTitle={t(stringPath + 'headingMsg')}
      infoIcon={
        <div className="delete-confirm-alert-icon mt-5">
          <InfoAlertIcon />
        </div>
      }
      popupContent={renderDynamicContent()}
      labelActionCancel={t('buttons.cancel')}
      labelActionOk={t(stringPath + 'continuteBtn')}
      onOk={onOk}
      onCancel={onCancel}
    />
  );
};

export default QueryWarningPopupAlert;
